import React, { FC, useCallback, useEffect, useRef, useState, useContext } from 'react';
import {
    IState, IDam, IInvestigationAssessment, IAssessmentProject, IProjectUser
} from "../types/types";

import { download, get, post } from "../fetchers/fetchers";
import fileDownload from 'js-file-download';
import { ITemplate } from "../types/types";
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import DialogContentText from '@material-ui/core/DialogContentText';
import { TasksDispatchContext, useTask } from '../stateManagement/context';
import {
    Button,
    Dialog, DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField, TextFieldProps,
    Tooltip,
    withStyles,
    makeStyles
} from "@material-ui/core";
import Assessment from "./assessment";
import { useParams } from "react-router";
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import { useHistory } from "react-router-dom";
import ProjectFailureModes from "./project_failure_modes";
import Documents from "./documents";
import { getStates } from '../stateManagement/data';
import CloseStateDialog from './close_state_dialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import TemplateDialog from './template_dialog';
import ImplementationDialog from './implementationdialog';
import Dam from './dam';
import { AxiosError } from 'axios';
import { API_URL } from "../env";
interface IStatesProps {
    assessment: IAssessmentProject;
    useGlobalContext?: boolean;

    minimal: boolean;
}

interface IRouteParams {
    id: string
}

function isAxiosError(error: unknown): error is AxiosError {
    return (error as AxiosError).isAxiosError !== undefined;
}

const useStyles = makeStyles((theme) => ({
    tableHeader: {
        backgroundColor: 'lightgrey',
    },
    tableHeaderCell: {
        textAlign: 'center',
    },
}));



const StatesList: FC<IStatesProps> = ({ assessment, useGlobalContext = true, minimal = false }) => {

    const classes = useStyles();
    let history = useHistory();

    const project_id = assessment.dam?.project_id ?? -1;
    const assessment_id = assessment.id ?? -1;

    let dispatch = useContext(TasksDispatchContext);
    let tasks = useTask();

    const [states, setStates] = useState<IState[]>([]);

    const [openCreateDialog, setOpenCreateDialog] = useState<boolean>(false);
    const newState = useRef<TextFieldProps>(null);

    const [currentState, setCurrentState] = useState<IState>();
    const [downloadState, setDownloadState] = useState<number>(-1);

    const [projectAccessLevel, setProjectAccessLevel] = useState<number>(0);

    const params = useParams<IRouteParams>();

    const [closeDialogOpen, setCloseDialogOpen] = useState(false);

    const [isLoading, setIsLoading] = useState(false);

    const [openTemplateDialog, setOpenTemplateDialog] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState<File | null>(null);

    const [openImplementationDialog, setOpenImplementationDialog] = useState(false);

    const openTemplateSelectDialog = useCallback(() => {
        setOpenTemplateDialog(true);
    }, []);

    const closeTemplateSelectDialog = useCallback(() => {
        setOpenTemplateDialog(false);
        setSelectedTemplate(null);
    }, []);

    const getProjectAccessLevel = async () => {
        const d = await get<IProjectUser>(API_URL + "projects/" + project_id + "/my_role");
        setProjectAccessLevel(d.access_level)
    }

    const handleTemplateSelection = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedTemplate(event.target.files ? event.target.files[0] : null);
    }, []);

    const getFile = (assessment_id: number, state_id: number) => {
        setDownloadState(state_id);
        openTemplateSelectDialog();
    };

    const handleTemplateDownload = useCallback((selectedTemplate: ITemplate | null, uploadedTemplate: File | null, state_id: number | null) => {
        console.log("handleTemplateDownload", state_id)
        if (selectedTemplate) {
            // Logic to handle the download of the report using the selected template goes here.
            // This can involve uploading the selected file to your server and then using it to generate the report.
            // For the sake of this example, we'll just directly download the file after the dialog is closed.
            if (selectedTemplate.uuid) {
                let selected_state_id = state_id ? state_id : -1;

                handleFileDownload(selectedTemplate, assessment_id, selected_state_id);
            }
            closeTemplateSelectDialog();

        }
    }, [selectedTemplate, closeTemplateSelectDialog]);

    // useState hook initialization
    const [loadingStates, setLoadingStates] = useState<{ [key: string]: boolean }>({});

    // Add this function to handle file downloading
    const handleFileDownload = (template: ITemplate, assessment_id: number, state_id: number) => {
        // Set loading state to true for specific download
        // Create a composite key
        const key = `${assessment_id}-${state_id}`;

        setLoadingStates({ ...loadingStates, [key]: true });

        downloadFile(template, assessment_id, state_id).then(({ data, filename }) => {
            fileDownload(data, filename);
            // Set loading state to false for specific download when it is complete
            setLoadingStates({ ...loadingStates, [key]: false });
        }).catch((error) => {
            setLoadingStates({ ...loadingStates, [key]: false });
        });
    }


    const handleSaveDialog = (newStateName: string) => {
        // Perform any necessary actions, e.g., create a new state with the given name

        // new state
        const newState: IState = {
            name: newStateName,
            assessment_project_id: assessment_id,
            uuid: -1
        }

        // post the new state
        addState(newState);

        handleCloseDialog();
    };

    const handleCloseDialog = () => {
        setCloseDialogOpen(false);
    };

    const handleOpenDialog = () => {
        setCloseDialogOpen(true);
    };


    const handleClose = () => {
        setOpenCreateDialog(false)
    }

    const handleOpen = () => {
        setOpenCreateDialog(true)
    }

    const convertToLocalTimeString = (utcString: string, timeZone: string = 'Australia/Sydney'): string => {
        const [datePart, timePart] = utcString.split(' ');
        const [year, month, day] = datePart.split('-').map(Number);
        const [hour, minute, second] = timePart.split(':').map(Number);
        const milliseconds = Number(second.toFixed(3).split('.')[1]);

        const utcDate = new Date(Date.UTC(year, month - 1, day, hour, minute, second, milliseconds));
        const formattedDate = utcDate.toLocaleString('en-US', {
            timeZone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        });

        return formattedDate.replace(',', '');
    }

    const handleProjectClick = (id: number, state_uuid?: number, access?: boolean) => {
        if (state_uuid) {
            if (access) {
                history.push("/assessment/" + id + "?state=" + state_uuid + "&access=true")
            } else {
                history.push("/assessment/" + id + "?state=" + state_uuid)
            }
        } else {
            history.push("/assessment/" + id)
        }
    }

    const handleImplementationClick = (id: number, state?: IState) => {
        setOpenImplementationDialog(true);
        setCurrentState(state);
    }

    const handleAddState = () => {
        if (!currentState) {
            throw new Error("Current Failure Mode needs to be set")
        }

        addState(currentState).then(() => setOpenCreateDialog(false))
    }

    const downloadFile = async (template: ITemplate, assessment_id: number, state_id: number) => {
        let query = "";
        if (state_id > 0) {
            query = "?state=" + state_id;
        }
        let base_url = "reports/";
        if (template.version == 2) {
            base_url = "reportv2/";
        }

        try {
            return await download(API_URL + base_url + template.uuid + "/" + assessment_id + "/assessment" + query);
        } catch (error) {
            if (isAxiosError(error) && error.response && error.response.status === 400) {
                throw new Error(`Download failed`);
            } else {
                throw error;
            }
        }
    }
    


    const addState = async (f: IState) => {
        let fm = { ...f }
        delete fm.id;
        delete fm.created_at;
        
        await post<IState>(API_URL + "states/", fm);

        if (!useGlobalContext) {
            fetchStates();
        } else {
            getStates(params.id, dispatch);
        }
    }

    const fetchStates = async () => {
        const response = await get<IState[]>(API_URL + "assessment_project/" + assessment_id + "/states");
        setStates(response);
    };


    useEffect(() => {
        if (!useGlobalContext && assessment_id > 0) {
            fetchStates();
        } else if (tasks.loaded) {
            setStates(tasks.states);
        }
    }, [tasks.loaded, useGlobalContext]);


    useEffect(() => {
        if (project_id > 0) {
            getProjectAccessLevel();
        }
    }, [project_id]);

    const renderState = (s: IState, i: any) => {
        return (
            <TableRow key={i}>
                {/* {minimal ? <TableCell>{assessment.dam?.name}</TableCell> : null} */}
                <TableCell>{s.name}</TableCell>
                <TableCell className={classes.tableHeaderCell}>{convertToLocalTimeString(s.created_at ?? '2023-05-02 07:29:57.854614')} </TableCell>
                <TableCell className={classes.tableHeaderCell}>
                    <Button variant="outlined" size="small" onClick={prevState => handleProjectClick(assessment_id ?? 0, s.uuid, false)}>View</Button>
                    <Button variant="outlined" size="small" onClick={prevState => handleProjectClick(assessment_id ?? 0, s.uuid, true)}>Edit</Button>
                    <Button variant="outlined" size="small" onClick={prevState => handleImplementationClick(assessment_id ?? 0, s)}>Implementation</Button>
                    {loadingStates[`${assessment_id}-${s.uuid}`]
                        ? <CircularProgress size={20} />
                        : <IconButton onClick={prevState => getFile(assessment_id ?? 0, s.uuid)}><SaveAltIcon /></IconButton>
                    }
                </TableCell>
            </TableRow>
        )
    }

    const renderTable = () => {
        return (
            <TableContainer component={Paper}>
                <Table>
                    <TableHead className={classes.tableHeader}>
                        <TableRow>
                            <TableCell className={classes.tableHeaderCell} >States</TableCell>
                            <TableCell className={classes.tableHeaderCell}>Closed</TableCell>
                            <TableCell className={classes.tableHeaderCell}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell><b>Current</b></TableCell>
                            <TableCell className={classes.tableHeaderCell}>
                                {projectAccessLevel >= 3 && <Button variant="outlined" size="small" color="secondary" onClick={prevState => handleOpenDialog()}>Close</Button>} </TableCell>
                            <TableCell className={classes.tableHeaderCell}><Button variant="outlined" size="small" onClick={prevState => handleProjectClick(assessment_id ?? 0)}>Open</Button>
                                {loadingStates[`${assessment_id}-${-1}`]
                                    ? <CircularProgress size={20} />
                                    : <IconButton onClick={prevState => getFile(assessment_id ?? 0, -1)}><SaveAltIcon /></IconButton>
                                }</TableCell>
                        </TableRow>
                        {states
                            .filter(s => s.parent_state_uuid === null)
                            .slice()
                            .sort((a, b) => (a.uuid < b.uuid ? 1 : -1))
                            .map((s, i) => {
                                return renderState(s, i)
                            })}
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }

    const renderRow = () => {


        return (
            <>
                <TableRow>
                    {/* <TableCell>{assessment.dam?.name}</TableCell> */}
                    <TableCell>Current</TableCell>
                    <TableCell className={classes.tableHeaderCell}>
                        {projectAccessLevel >= 3 && <Button variant="outlined" size="small" color="secondary" onClick={prevState => handleOpenDialog()}>Close</Button>} </TableCell>
                    <TableCell className={classes.tableHeaderCell}><Button variant="outlined" size="small" onClick={prevState => handleProjectClick(assessment_id ?? 0)}>Open</Button>
                        {loadingStates[`${assessment_id}-${-1}`]
                            ? <CircularProgress size={20} />
                            : <IconButton onClick={prevState => getFile(assessment_id ?? 0, -1)}><SaveAltIcon /></IconButton>
                        }</TableCell>
                </TableRow>


                {states
                    .filter(s => s.parent_state_uuid === null)
                    .slice()
                    .sort((a, b) => (a.uuid < b.uuid ? 1 : -1))
                    .map((s, i) => {
                        return renderState(s, i)
                    })}
            </>
        )
    }


    return (
        <>
            <TemplateDialog
                open={openTemplateDialog}
                onClose={closeTemplateSelectDialog}
                onDownload={handleTemplateDownload}
                state_id={downloadState}
            />

            <CloseStateDialog
                open={closeDialogOpen}
                onClose={handleCloseDialog}
                onSave={handleSaveDialog}
                currentStateId={0} // Replace with the actual current state ID
                assessmentId={assessment_id ?? 0}
            />

            <ImplementationDialog
                open={openImplementationDialog}
                onClose={() => setOpenImplementationDialog(false)}
                assessmentId={assessment_id ?? 0}
                parentState={currentState}
                states={states}
            />
            {!minimal ? renderTable() : null}

            {minimal ? renderRow() : null}


        </>
    );
};

export default StatesList;
